import { render, staticRenderFns } from "./businessStage.vue?vue&type=template&id=390b35d1&scoped=true"
import script from "./businessStage.vue?vue&type=script&lang=js"
export * from "./businessStage.vue?vue&type=script&lang=js"
import style0 from "./businessStage.vue?vue&type=style&index=0&id=390b35d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b35d1",
  null
  
)

export default component.exports